import { render, staticRenderFns } from "./SkinPricingEntriesMultiFetchDialog.vue?vue&type=template&id=bd0d230a&scoped=true&"
import script from "./SkinPricingEntriesMultiFetchDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinPricingEntriesMultiFetchDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0d230a",
  null
  
)

export default component.exports